import React, { useEffect, useState } from 'react';
import { useSection } from '../../common/SectionProvider';
import FavoriteButtonMarket from './common/FavoriteButtonMarket';
import BetInfoButton from './common/BetInfoButton';
import Img from './common/Img';
import CashoutIcon from './common/cashout/CashoutIcon';
import { getBetUniqueId } from '../utils/getBetUniqueId';

export default function Bet(props) {
    const [toggled, setToggled] = useState(true);
    const section = useSection().current;

    useEffect(() => {
        function listener(e) {
            setToggled(e.detail.expanded);
        }

        window.addEventListener('xs-expandall', listener);

        return () => window.removeEventListener('xs-expandall', listener);
    }, []);

    return (
        <div className="c_10">
            <div className="c_10_1" onClick={() => setToggled(prev => !prev)}>
                {section === 'live' &&
                    <FavoriteButtonMarket id={getBetUniqueId(props.data)} />
                }
                <div className="c_10_1_2">{props.desc}</div>
                <BetInfoButton desc={props.desc} odds={props.data.odds} />
                <CashoutIcon bet={props.data} />
                <Img
                    className="c_10_1_3"
                    src={toggled ? 'collapse.svg' : 'expand.svg'}
                    height="12px"
                    width="12px"
                />
            </div>
            {toggled &&
                <div className="c_10_2">
                    {props.children}
                </div>
            }
        </div>
    );
}
